import React from 'react';
import { HiOutlineMail } from 'react-icons/hi';

/**
 * EmailIcon
 * Ikona obálky pre kontaktné informácie s e-mailovou adresou.
 */
const EmailIcon = ({ className = 'inline-block align-middle', ...props }) => (
  <HiOutlineMail className={className} {...props} />
);

export default EmailIcon;

